var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"base__status-v2",class:[
        `status-color-${_setup.props.colorType}-${_setup.resolvedColor}`,
        _setup.props.isShadow && `is-shadow-${_setup.resolvedColor}`,
        _setup.props.rounded && `is-rounded-${_setup.props.rounded}`,
    ]},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_setup.props.text)+" ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }